<script setup lang="ts">
    import { TriangleAlertIcon } from '@lucide/vue';
    import { __ } from '@/js/stores/expressions';
    import EchoButton from '../EchoButton.vue';

    defineProps<{
        categories: string[];
    }>();

    defineEmits<{
        (e: 'remove'): void;
    }>();
</script>

<template>
    <div
        role="alert"
        class="mx-4 my-4 flex gap-3 rounded-lg border border-sentiment-negative bg-sentiment-negative/10 p-4"
    >
        <TriangleAlertIcon
            class="size-5 shrink-0 text-sentiment-negative mt-0.5"
            aria-hidden="true"
        />
        <div class="flex flex-col gap-2">
            <p class="text-body-bold">{{ __('invalid-filters-title') }}</p>
            <ul class="list-disc pl-5 text-body">
                <li v-for="category in categories" :key="category">{{ category }}</li>
            </ul>
            <p class="text-body">{{ __('invalid-filters-description') }}</p>
            <div>
                <EchoButton variant="primary" size="small" @click="$emit('remove')">
                    {{ __('invalid-filters-remove') }}
                </EchoButton>
            </div>
        </div>
    </div>
</template>
